<template>
    <div class="update-banner text-white u-flex u-flex--center">
        Ein Update ist verfügbar.
        <button
            class="text-white u-reset-button u-inline-block u-underline p-0 ml-6"
            @click="$emit('submit')"
        >Jetzt aktualisieren!</button>
    </div>
</template>

<script>
export default {
    name: 'ServiceWorkerUpdateBanner',
}
</script>

<style lang="scss" scoped>
.u-underline {
    text-decoration: underline;

    @include interaction {
        text-decoration: none;
    }
}

.update-banner {
    position: fixed;
    top: $head-bar-height;
    left: 0;
    height: $update-banner-height;
    width: 100vw;
    background: $highlight-color;
    z-index: $index-above;
}
</style>
